export const visit = (vm, at) => {
at({ "de": { "conversationsVisitorUIAvailability": { "sameDay": "Wir sind heute um {{time}} wieder da.", "nextDay": "Wir sind morgen um {{time}} wieder da.", "nextWeek": "Wir sind am {{dayOfWeek}} um {{time}} wieder da." } } });
};